import { useMemo } from 'react';

import { EWidgetRegion } from '#shared';

export const useLayoutManagerConfig = (
  selectedLayouts: EWidgetRegion[],
  centerExtraWidthPx = 0,
) => {
  const activeRegions = useMemo(
    () =>
      Object.values(EWidgetRegion).filter(region =>
        selectedLayouts.includes(region),
      ),
    [selectedLayouts],
  );

  const gridTemplateColumns = useMemo(() => {
    const regionCount = activeRegions.length;

    // Cut half of the added center from side regions
    const sideWidthReductionPx = Math.max(
      0,
      Math.floor(centerExtraWidthPx / 2),
    );

    if (regionCount === 3) {
      if (centerExtraWidthPx > 0) {
        // A trick to count gap between regions in calc
        // TODO: consider gap between regions,
        const gap = 8;
        return `calc(25% - ${sideWidthReductionPx + gap}px) calc(50% + ${centerExtraWidthPx}px) calc(25% - ${sideWidthReductionPx + gap}px)`;
      }
      return '25% 50% 25%';
    }

    if (regionCount === 2) {
      if (
        selectedLayouts.includes(EWidgetRegion.Left) &&
        selectedLayouts.includes(EWidgetRegion.Right)
      ) {
        return '50% 50%';
      }
      if (
        selectedLayouts.includes(EWidgetRegion.Left) &&
        selectedLayouts.includes(EWidgetRegion.Center)
      ) {
        return '37.5% 62.5%';
      }
      if (
        selectedLayouts.includes(EWidgetRegion.Center) &&
        selectedLayouts.includes(EWidgetRegion.Right)
      ) {
        return '62.5% 37.5%';
      }
    }

    if (regionCount === 1) {
      return '100%';
    }
    return '';
  }, [activeRegions, selectedLayouts, centerExtraWidthPx]);

  const gridTemplateAreas = useMemo(() => {
    const areas: string[] = [];

    if (selectedLayouts.includes(EWidgetRegion.Left)) {
      areas.push(EWidgetRegion.Left);
    }
    if (selectedLayouts.includes(EWidgetRegion.Center)) {
      areas.push(EWidgetRegion.Center);
    }
    if (selectedLayouts.includes(EWidgetRegion.Right)) {
      areas.push(EWidgetRegion.Right);
    }

    return `"${areas.join(' ')}"`;
  }, [selectedLayouts]);

  const showLayoutToggle = !selectedLayouts.includes(EWidgetRegion.Center);

  return {
    activeRegions,
    gridTemplateColumns,
    gridTemplateAreas,
    showLayoutToggle,
  };
};
